import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type {
  MembershipActivity,
  TeamRole,
} from '@store/reducers/dashboard/types'
import type React from 'react'

interface Props {
  current: TeamRole
  activity: MembershipActivity
  personal: boolean
  disabled: boolean
}

export const RoleContent: React.FC<Props> = ({
  current,
  activity,
  disabled,
  personal,
}) => {
  const manager = current === 'MANAGER'
  const member = current === 'MEMBER'

  if (disabled && personal) {
    return <DropdownMenu.Button danger id="leave_team" title="Leave Team" />
  }

  if (activity === 'active') {
    return (
      <>
        {manager && <DropdownMenu.Button id="member" title="Assign member" />}
        {member && <DropdownMenu.Button id="manager" title="Assign manager" />}
        <DropdownMenu.Divider />
        <DropdownMenu.Button id="suspend" title="Suspend user" />
        {!personal && (
          <DropdownMenu.Button danger id="delete" title="Remove from Team" />
        )}
        {personal && (
          <DropdownMenu.Button danger id="leave_team" title="Leave Team" />
        )}
      </>
    )
  }

  if (activity === 'suspended') {
    return (
      <>
        <DropdownMenu.Button id="unsuspend" title="Make a member" />
        <DropdownMenu.Divider />
        <DropdownMenu.Button danger id="delete" title="Remove from Team" />
      </>
    )
  }

  return (
    <DropdownMenu.Button
      danger
      id="cancel_invitation"
      title="Cancel invitation"
    />
  )
}
